import { Box, CircularProgress } from "@mui/material";
import Text from "../../../../components/ui/Text";

export const LoadingState = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "400px",
    }}
  >
    <CircularProgress size={40} sx={{ mb: 2 }} />
    <Text variant="paragraph2" sx={{ color: "#666" }}>
      Loading games...
    </Text>
  </Box>
);

export const ErrorState = ({ error, onRetry }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "400px",
    }}
  >
    <Box sx={{ textAlign: "center" }}>
      <Text variant="paragraph2" sx={{ color: "#d32f2f", mb: 2 }}>
        {error}
      </Text>
      <Text
        variant="paragraph3"
        sx={{
          color: "#1890FF",
          cursor: "pointer",
          textDecoration: "underline",
        }}
        onClick={onRetry}
      >
        Try again
      </Text>
    </Box>
  </Box>
);

export const EmptyState = () => (
  <Box sx={{ textAlign: "center", py: 8 }}>
    <Text variant="paragraph2" sx={{ color: "#666", mb: 2 }}>
      No upcoming games found
    </Text>
    <Text variant="paragraph3" sx={{ color: "#999" }}>
      Check back later for new games!
    </Text>
  </Box>
);
